import env from '../../envVariables';

export const postMessageToIframeParent = (message) => {
  console.log('outgoingMessage_messageEvent', message);
  window.parent.postMessage(message, env.REACT_APP_MESSAGE_EVENT_TARGET_ORIGIN || '*');
};
